const routes = [
    {
        path : "enterprise-add",
        name : "enterprise-add",
        meta : {
            title : "企业信息录入"
        },
        component: () => import('@/pages/enterprise/input/Index')
    },
    {
        path : "enterprise-edit/:id",
        name : "enterprise-edit",
        meta : {
            title : "企业信息编辑"
        },
        component: () => import('@/pages/enterprise/input/Index')
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/enterprise/input_enterprise/index.js